export default __webpack_public_path__ + "static/media/82.fd271ea3.jpg";